'use strict';

module.exports = {
    validate: function ($this, target) {
        var formError = false;
        var $variationAttributes = $this.parents('.pdp-right-wrapper').find('.attributes .row');
        $variationAttributes.find('.error-msg').addClass('d-none');
        $variationAttributes.find('label').removeClass('d-none');
        if ($(target).hasClass('sticky-add-to-cart')) {
            $('.error-msg').addClass('d-none');
            $variationAttributes = $this.parents('.variations-overlay-content').find('.attributes .row');
        }
        if ($variationAttributes) {
            $variationAttributes.each(function () {
                const $thisInner = $(this);
                if ($thisInner.data('attr') === 'color') {
                    if (!$thisInner.find('.attribute .color-value').hasClass('selected')) {
                        $thisInner.find('.error-msg').removeClass('d-none');
                        $thisInner.find('label').addClass('d-none');
                        formError = true;
                    }
                } else if ($thisInner.find('.attribute .custom-select').val() === '') {
                    $thisInner.find('.error-msg').removeClass('d-none');
                    $thisInner.find('label').addClass('d-none');
                    formError = true;
                }
            });
        }
        return formError;
    },
};
